import React from 'react';
import { LuImage } from 'react-icons/lu';
import { channelLabel } from '../../../utils/sources.js';
import { cx } from '../../../utils/cx.js';
import Badge from '../../ui/Badge';
import StoresFoundBadge from './StoresFoundBadge';
import { formatDate } from '../../../utils/weekFormat.js';
import { plural } from '../../../utils/text.js';
import { shortVersion, versionTitle } from './topicsVersion.js';

const PostItem = ({ post, active, onSelect }) => (
  <li>
    <button
      type="button"
      onClick={() => onSelect(post.visit_key)}
      aria-current={active ? 'true' : undefined}
      className={cx(
        'w-full px-4 py-3 text-left outline-none transition-colors focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-500',
        active ? 'bg-brand-50 dark:bg-brand-950' : 'hover:bg-gray-50 dark:hover:bg-white/[0.03]',
      )}
    >
      <div className="flex items-center gap-2 text-xs text-gray-400 dark:text-gray-500">
        <span className="font-medium text-gray-700 dark:text-gray-200">{formatDate(post.started_at)}</span>
        <span className="truncate">{channelLabel(post.channel)}</span>
        {post.topics_version && <span className="flex-shrink-0" title={versionTitle(post.topics_version)}>{shortVersion(post.topics_version)}</span>}
        {post.picture_count > 0 && <span className="ml-auto flex flex-shrink-0 items-center gap-1"><LuImage className="h-3 w-3" aria-hidden />{post.picture_count}</span>}
      </div>
      <p className="mt-1 line-clamp-2 text-xs text-gray-600 dark:text-gray-300">{post.excerpt}</p>
      <div className="mt-2 flex flex-wrap gap-1.5">
        {post.rows ? <Badge size="sm" tone="blue">{plural(post.rows, 'ligne')}</Badge> : <Badge size="sm">Aucun topic</Badge>}
        {post.proposals > 0 && <Badge size="sm" tone="amber">{plural(post.proposals, 'proposition')}</Badge>}
        {post.visits > 0 && <StoresFoundBadge found={post.stores_found} visits={post.visits} />}
      </div>
    </button>
  </li>
);

export default PostItem;
